// ///////////Pre-Made Worksheet Constants//////////////////////////

/*
-------------------------------------------
--------- MAIN CLASSROOMS  CONSTANTS ---------
-------------------------------------------
*/
export const HANDLE_FETCH_CLASSROOMS = "HANDLE_FETCH_CLASSROOMS";

export interface IHandleFetchClassrooms {
  type: typeof HANDLE_FETCH_CLASSROOMS;
  payload: {
    isStats: boolean;
  };
}

export const SET_CLASSROOM_STATS = "SET_CLASSROOM_STATS";

export interface IHandleSetClassroomStats {
  type: typeof SET_CLASSROOM_STATS;
  payload: {
    stats: [];
    classroomId: string;
  };
}

export const HANDLE_FETCH_CLASSROOM_REPORT_PDF = "HANDLE_FETCH_CLASSROOM_REPORT_PDF";

export interface IHandleFetchClassroomReportPDF {
  type: typeof HANDLE_FETCH_CLASSROOM_REPORT_PDF;
  payload: FetchClassroomReportPDF;
}

export const HANDLE_DELETE_MULTIPLE_ITEMS_FROM_CLASS = "HANDLE_DELETE_MULTIPLE_ITEMS_FROM_CLASS";

export interface IHandleDeleteMultipleItems {
  type: typeof HANDLE_DELETE_MULTIPLE_ITEMS_FROM_CLASS;
  payload: DeleteRequest;
  classId: string;
}

export const HANDLE_OPEN_SELECTED_ITEM_DETAILS_CLASSROOM =
  "HANDLE_OPEN_SELECTED_ITEM_DETAILS_CLASSROOM";

export interface IHandleOpenSelectedItemDetailsClassroom {
  type: typeof HANDLE_OPEN_SELECTED_ITEM_DETAILS_CLASSROOM;
  payload: OpenDetailsRequest;
}

export const HANDLE_DELETE_CLASSROOM = "HANDLE_DELETE_CLASSROOM";

/** @params
 * payload: classroom id */
export interface IHandleDeleteClass {
  type: typeof HANDLE_DELETE_CLASSROOM;
  payload: string;
}

export const SET_CLASSROOMS = "SET_CLASSROOMS";

export interface IHandleSetClassrooms {
  type: typeof SET_CLASSROOMS;
  payload: Classroom[];
}

export const HANDLE_CREATE_CLASSROOM = "HANDLE_CREATE_CLASSROOM";

export interface IHandleCreateClassroom {
  type: typeof HANDLE_CREATE_CLASSROOM;
  payload: CreateClassroomPayload;
}

export const SET_ACTIVE_CLASSROOM = "SET_ACTIVE_CLASSROOM";

export interface ISetActiveClassroom {
  type: typeof SET_ACTIVE_CLASSROOM;
  payload: Classroom;
}

export const HANDLE_FETCH_CLASSROOM = "HANDLE_FETCH_CLASSROOM";

export interface IHandleFetchClassroom {
  type: typeof HANDLE_FETCH_CLASSROOM;
  payload: string;
}

export const HANDLE_UPDATE_CLASSROOM = "HANDLE_UPDATE_CLASSROOM";

export interface IHandleUpdateClassroom {
  type: typeof HANDLE_UPDATE_CLASSROOM;
  payload: ClassroomUpdatePayload; // It should be Payload object with changes for saga
  source: UpdateSource;
}

export const HANDLE_UPDATE_CLASSROOM_ARCHIVED = "HANDLE_UPDATE_CLASSROOM_ARCHIVED";

export interface IHandleUpdateClassroomArchived {
  type: typeof HANDLE_UPDATE_CLASSROOM_ARCHIVED;
  payload: UpdateClassroomArchivedPayload;
  source: Source;
}

export const HANDLE_ADD_CLASSROOM_INSTRUCTOR = "HANDLE_ADD_CLASSROOM_INSTRUCTOR";

export interface IhandleAddClassroomInstructor {
  type: typeof HANDLE_ADD_CLASSROOM_INSTRUCTOR;
  payload: Partial<Instructor>[];
}

export const SET_STUDENT_ACTIVE_STRATEGY = "SET_STUDENT_ACTIVE_STRATEGY";
export const SET_CLASS_UNIT_FILTER_OPTIONS = "SET_CLASS_UNIT_FILTER_OPTIONS";

export const HANDLE_FETCH_CLASSROOM_STUDENTS = "HANDLE_FETCH_CLASSROOM_STUDENTS";

export interface IHandleFetchClassroomStudents {
  type: typeof HANDLE_FETCH_CLASSROOM_STUDENTS;
}

export const SET_CLASSROOM_STUDENTS = "SET_CLASSROOM_STUDENTS";

export interface ISetClassroomStudents {
  type: typeof SET_CLASSROOM_STUDENTS;
  payload: Student[];
}

/*
-------------------------------------------
------ LESSONS CLASSROOMS CONSTANTS ------
-------------------------------------------
*/
export const HANDLE_RESCHEDULE_CLASSROOM_LESSONS = "HANDLE_RESCHEDULE_CLASSROOM_LESSONS";

export interface IRescheduleClassroomsLesson {
  type: typeof HANDLE_RESCHEDULE_CLASSROOM_LESSONS;
  payload: RescheduleClassroomLesson;
  source: Source;
}

export const HANDLE_UNASSIGN_CLASSROOM_LESSON = "HANDLE_UNASSIGN_CLASSROOM_LESSON";

export interface IUnassignClassroomLesson {
  type: typeof HANDLE_UNASSIGN_CLASSROOM_LESSON;
  payload: UnassignClassroomLesson;
}

export const HANDLE_ASSIGN_LESSONS_TO_CLASSROOM = "HANDLE_ASSIGN_LESSONS_TO_CLASSROOM";

export interface IHandleAssignLessonsToClass {
  type: typeof HANDLE_ASSIGN_LESSONS_TO_CLASSROOM;
  payload: AssignLessonsClassRequest;
  source: Source;
  problemsCount: number;
}

export const HANDLE_FETCH_CLASSROOM_LESSONS = "HANDLE_FETCH_CLASSROOM_LESSONS";

export interface IHandleFetchClassroomLessons {
  type: typeof HANDLE_FETCH_CLASSROOM_LESSONS;
}

export const SET_CLASSROOM_ACTIVE_LESSON = "SET_CLASSROOM_ACTIVE_LESSON";

export interface ISetClassroomActiveLesson {
  type: typeof SET_CLASSROOM_ACTIVE_LESSON;
  payload: Lesson;
}

export const SET_CLASSROOM_LESSONS = "SET_CLASSROOM_LESSONS";

export interface ISetClassroomLessons {
  type: typeof SET_CLASSROOM_LESSONS;
  payload: Lesson[];
}

export const HANDLE_FETCH_CLASSROOM_LESSONS_LIST = "HANDLE_FETCH_CLASSROOM_LESSONS_LIST";

export interface IHandleFetchClassroomLessonsList {
  type: typeof HANDLE_FETCH_CLASSROOM_LESSONS_LIST;
}

/*
-------------------------------------------
----- WORKSHEETS CLASSROOMS CONSTANTS -----
-------------------------------------------
*/
export const HANDLE_FETCH_CLASSROOM_WORKSHEETS_LIST = "HANDLE_FETCH_CLASSROOM_WORKSHEETS_LIST";

export interface IHandleFetchClassroomWorksheetsList {
  type: typeof HANDLE_FETCH_CLASSROOM_WORKSHEETS_LIST;
}

export const SET_CLASSROOM_WORKSHEETS = "SET_CLASSROOM_WORKSHEETS";

export interface ISetClassroomWorksheets {
  type: typeof SET_CLASSROOM_WORKSHEETS;
  payload: Worksheet[];
}

export const HANDLE_RESCHEDULE_CLASSROOM_WORKSHEETS = "HANDLE_RESCHEDULE_CLASSROOM_WORKSHEETS";

export interface IHandleRescheduleClassroomWorksheets {
  type: typeof HANDLE_RESCHEDULE_CLASSROOM_WORKSHEETS;
  payload: RescheduleClassroomWorksheetsPayload;
  source: Source;
}

export const HANDLE_ASSIGN_CLASSROOM_WORKSHEETS = "HANDLE_ASSIGN_CLASSROOM_WORKSHEETS";

export interface IHandleAssignClassroomWorksheets {
  type: typeof HANDLE_ASSIGN_CLASSROOM_WORKSHEETS;
  payload: AssignClassroomWorksheetsPayload;
  source: Source;
}

export const HANDLE_UNASSIGN_CLASSROOM_WORKSHEET = "HANDLE_UNASSIGN_CLASSROOM_WORKSHEET";

export interface IHandleUnassignClassroomWorksheet {
  type: typeof HANDLE_UNASSIGN_CLASSROOM_WORKSHEET;
  payload: UnassignClassroomWorksheet;
}

export const SET_CLASSROOM_ACTIVE_WORKSHEET = "SET_CLASSROOM_ACTIVE_WORKSHEET";

export interface ISetClassroomActiveWorksheet {
  type: typeof SET_CLASSROOM_ACTIVE_WORKSHEET;
  payload: Worksheet;
}

/*
-------------------------------------------
------- TEST CLASSROOMS  CONSTANTS --------
-------------------------------------------
*/

export const HANDLE_FETCH_CLASSROOM_TESTS_LIST = "HANDLE_FETCH_CLASSROOM_TESTS_LIST";

export interface IHandleFetchClassroomTestsList {
  type: typeof HANDLE_FETCH_CLASSROOM_TESTS_LIST;
}

export const HANDLE_ASSIGN_CLASSROOM_TEST = "HANDLE_ASSIGN_CLASSROOM_TEST";

export interface IHandleAssignClassroomTest {
  type: typeof HANDLE_ASSIGN_CLASSROOM_TEST;
  payload: AssignTestToClassroomPayload;
  source: Source;
}

export const HANDLE_UNASSIGN_CLASSROOM_TEST = "HANDLE_UNASSIGN_CLASSROOM_TEST";

export interface IHandleUnassignClassroomTest {
  type: typeof HANDLE_UNASSIGN_CLASSROOM_TEST;
  payload: UnassignTestFromClassroomPayload;
}

export const HANDLE_RESCHEDULE_CLASSROOM_TESTS = "HANDLE_RESCHEDULE_CLASSROOM_TESTS";

export interface IHandleRescheduleClassroomTest {
  type: typeof HANDLE_RESCHEDULE_CLASSROOM_TESTS;
  payload: RescheduleClassroomTest;
  source: Source;
}

export const SET_CLASSROOM_TESTS = "SET_CLASSROOM_TESTS";

export interface ISetClassroomTests {
  type: typeof SET_CLASSROOM_TESTS;
  payload: Test[];
}

export const HANDLE_UPDATE_CLASSROOM_TEST = "HANDLE_UPDATE_CLASSROOM_TEST";

export interface IHandleUpdateClassroomTest {
  type: typeof HANDLE_UPDATE_CLASSROOM_TEST;
  payload: UpdateTestPayload;
  testChanges: TestChangesRequest;
  source: Source;
}

export const HANDLE_FETCH_CLASSROOM_ACTIVE_TEST = "HANDLE_FETCH_CLASSROOM_ACTIVE_TEST";

export interface IHandleFetchClassroomActiveTest {
  type: typeof HANDLE_FETCH_CLASSROOM_ACTIVE_TEST;
  payload: string;
}

export const SET_CLASSROOM_ACTIVE_TEST = "SET_CLASSROOM_ACTIVE_TEST";

export interface ISetClassroomActiveTest {
  type: typeof SET_CLASSROOM_ACTIVE_TEST;
  payload: Test;
}

/*
-------------------------------------------
------- SESSION CLASSROOM  CONSTANTS ------
-------------------------------------------
*/
export const HANDLE_ASSIGN_CLASSROOM_SESSION = "HANDLE_ASSIGN_CLASSROOM_SESSION";
export const HANDLE_UPDATE_CLASSROOM_SESSION = "HANDLE_UPDATE_CLASSROOM_SESSION";

/*
-------------------------------------------
------- CALENDAR CLASSROOM  CONSTANTS -----
-------------------------------------------
*/
export const SET_CLASSROOM_CALENDAR_LOADING = "SET_CLASSROOM_CALENDAR_LOADING";

export const HANDLE_FETCH_CLASSROOM_CALENDAR_DATA = "HANDLE_FETCH_CLASSROOM_CALENDAR_DATA";

export interface IHandleFetchClassCalendarData {
  type: typeof HANDLE_FETCH_CLASSROOM_CALENDAR_DATA;
  payload: string;
}

/*
-------------------------------------------
-------------------------------------------
-------------------------------------------
*/

export const HANDLE_FETCH_CLASSROOM_WORKSHEETS_BY_CATEGORIES =
  "HANDLE_FETCH_CLASSROOM_WORKSHEETS_BY_CATEGORIES";

export interface IHandleFetchClassroomWorksheetsByCategories {
  type: typeof HANDLE_FETCH_CLASSROOM_WORKSHEETS_BY_CATEGORIES;
  payload: string[];
}

export const HANDLE_ASSIGN_CLASSROOM_ASSIGNMENT_TO_STUDENTS =
  "HANDLE_ASSIGN_CLASSROOM_ASSIGNMENT_TO_STUDENTS";

export interface IHandleAssignClassroomAssignmentToStudents {
  type: typeof HANDLE_ASSIGN_CLASSROOM_ASSIGNMENT_TO_STUDENTS;
  payload: string;
  assignmentType: string;
}

export const HANDLE_ASSIGN_CLASSROOM_WORKSHEET_TO_STUDENTS =
  "HANDLE_ASSIGN_CLASSROOM_WORKSHEET_TO_STUDENTS";

/* Actions awating BE endpoints */
export interface IHandleAssignClassroomWorksheetToStudents {
  type: typeof HANDLE_ASSIGN_CLASSROOM_WORKSHEET_TO_STUDENTS;
  payload: string; // classroom lesson id
}

export const HANDLE_ASSIGN_CLASSROOM_TEST_TO_STUDENTS = "HANDLE_ASSIGN_CLASSROOM_TEST_TO_STUDENTS";

export interface IHandleAssignClassroomTestToStudents {
  type: typeof HANDLE_ASSIGN_CLASSROOM_TEST_TO_STUDENTS;
  payload: string; // classroom lesson id
}

export const SET_CLASSROOM_SUMMARY = "SET_CLASSROOM_SUMMARY";

export interface ISetClassroomSummary {
  type: typeof SET_CLASSROOM_SUMMARY;
  payload: {
    classroomId: string;
    classroomSummary: ClassSummary;
  };
}

export const HANDLE_FETCH_CLASSROOM_OVERDUE_STATS = "HANDLE_FETCH_CLASSROOM_OVERDUE_STATS";
export interface IHandleFetchClassroomOverdueStats {
  type: typeof HANDLE_FETCH_CLASSROOM_OVERDUE_STATS;
  payload: {
    classroomId: string;
  };
}
export const HANDLE_FETCH_CLASSROOM_PROBLEMS_STATS = "HANDLE_FETCH_CLASSROOM_PROBLEMS_STATS";
export interface IHandleFetchClassroomProblemsStats {
  type: typeof HANDLE_FETCH_CLASSROOM_PROBLEMS_STATS;
  payload: {
    classroomId: string;
  };
}

export const SET_CLASSROOM_OVERDUE_STATS = "SET_CLASSROOM_OVERDUE_STATS";
export interface ISetClassroomOverdueStats {
  type: typeof SET_CLASSROOM_OVERDUE_STATS;
  payload: {
    overdue;
  };
}
export const SET_CLASSROOM_PROBLEMS_STATS = "SET_CLASSROOM_PROBLEMS_STATS";

export interface ISetClassroomProblemsStats {
  type: typeof SET_CLASSROOM_PROBLEMS_STATS;
  payload: {
    problems;
  };
}

export const SET_CLASSROOMS_SIMPLIFIED_LOADING = "SET_CLASSROOMS_SIMPLIFIED_LOADING";
export interface ISetClassroomsSimplifiedLoading {
  type: typeof SET_CLASSROOMS_SIMPLIFIED_LOADING;
  payload: {
    isLoading: boolean;
  };
}
